import React from 'react';
import { ChevronRightIcon, ClockIcon, MapPinIcon, SparklesIcon } from 'lucide-react';
import { followUps, registrations } from '../../data/loisirs';
export function MyActivities() {
  return <section aria-labelledby="my-activities-title" className="mt-14" data-id="element-1510" data-mp="16v2i4saygsz4">
      <h2 id="my-activities-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1511" data-mp="16wx3u8u1wp49">
        My activities
      </h2>
      <p className="mt-1 text-[15px] text-slate-600" data-id="element-1512" data-mp="x4hn1euhq6ky">Your registrations and your family’s.</p>

      <div className="mt-6 grid gap-5 lg:grid-cols-[minmax(0,1fr)_minmax(0,340px)] lg:gap-8" data-id="element-1513" data-mp="11vzqqanwel9m">
        <ul className="space-y-3" data-id="element-1514" data-mp="o4l4zw2lw5yv">
          {registrations.map(registration => <li key={registration.id} data-id="element-1515" data-mp="t2wfm90q6ki5">
              <button type="button" className="group flex w-full items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 text-left transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1516" data-mp="t3xqacdtx4zc">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-slate-100 text-sm font-bold text-ville-navy" aria-hidden="true" data-id="element-1517" data-mp="3kei6poxm7uo8">
                  {registration.initials}
                </span>
                <span className="min-w-0 flex-1" data-id="element-1518" data-mp="3pca1cqpn9uw4">
                  <span className="flex flex-wrap items-center gap-2" data-id="element-1519" data-mp="31lo29oxmbky9">
                    <span className="font-bold text-ville-navy" data-id="element-1520" data-mp="31jtfe52sdirj">{registration.activity}</span>
                    <span className="rounded-full bg-ville-indigo-soft px-2.5 py-0.5 text-xs font-bold text-ville-indigo" data-id="element-1521" data-mp="2wl03ui7281u0">
                      {registration.participant} · registered
                    </span>
                  </span>
                  <span className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-500" data-id="element-1522" data-mp="2hxooe57rbxom">
                    <span className="flex items-center gap-1.5" data-id="element-1523" data-mp="2dxekqz7ftjcx">
                      <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-1524" data-mp="gvyzuz0ozdud" />
                      {registration.schedule}
                    </span>
                    <span className="flex items-center gap-1.5" data-id="element-1525" data-mp="ltr1wlv1wgca">
                      <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-1526" data-mp="qm23dt5fwa6y" />
                      {registration.place}
                    </span>
                  </span>
                  <span className="mt-1 block text-sm font-semibold text-ville-navy" data-id="element-1527" data-mp="vmy1tr70v44z">{registration.nextSession}</span>
                </span>
                <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400 transition-colors duration-150 ease-ville group-hover:text-ville-indigo" aria-hidden="true" data-id="element-1528" data-mp="2vo71qftnp6k" />
              </button>
            </li>)}
        </ul>

        <aside aria-label="ATNA follow-ups" className="rounded-2xl border border-slate-200 bg-slate-50 p-5" data-id="element-1529" data-mp="1japqlu9r19n5">
          <p className="flex items-center gap-2 text-sm font-bold text-ville-indigo" data-id="element-1530" data-mp="1o91023w4ti4u">
            <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-1531" data-mp="38rblk353nk9p" />
            ATNA follow-ups
          </p>
          <ul className="mt-3 space-y-3" data-id="element-1532" data-mp="33ryn0l4v8ora">
            {followUps.map(item => <li key={item} className="rounded-xl bg-white px-4 py-3 text-sm leading-relaxed text-slate-600" data-id="element-1533" data-mp="2z1rzkom3baam">
                {item}
              </li>)}
          </ul>
        </aside>
      </div>
    </section>;
}